import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { updateUser } from '../../redux/User';
import userApiClient from 'services/networking/userApiClient';

export const useFetchUser = () => {
  const dispatch = useDispatch();

  const fetchUser = useCallback(async () => {
    const { response, error } = await userApiClient.getUser();
    if (error)
      toast.error(error.response?.body?.message ?? error.message, {
        hideProgressBar: false,
        theme: 'colored',
      });

    dispatch(updateUser(response));
  }, [dispatch]);

  return { fetchUser };
};
